import React, { useState, useEffect, useMemo } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase/config';

// 에이전트 연결 상태 배너 (공용, 2026-07-30) — 수집함과 동일 판정
// 명세서 작성 전 "수집이 돌고 있는가"를 먼저 알리는 용도. 하트비트 10분 이내=🟢, 이후=🟡, 이력 없음=⚪

const toMs = (t) => {
    if (!t) return 0;
    if (typeof t.toDate === 'function') return t.toDate().getTime();
    const d = new Date(t); return isNaN(d) ? 0 : d.getTime();
};
const agoText = (ms) => {
    const min = Math.floor((Date.now() - ms) / 60000);
    if (min < 1) return '방금 전';
    if (min < 60) return `${min}분 전`;
    const h = Math.floor(min / 60);
    if (h < 24) return `${h}시간 전`;
    return `${Math.floor(h / 24)}일 전`;
};

function AgentStatusBanner({ user, style }) {
    const [agentStatus, setAgentStatus] = useState(undefined);   // undefined=로딩중, null=문서 없음

    useEffect(() => {
        const labId = user?.companyId || auth.currentUser?.uid;
        if (!labId) return;
        getDoc(doc(db, 'agentStatus', labId))
            .then(s => setAgentStatus(s.exists() ? s.data() : null))
            .catch(() => setAgentStatus(null));
    }, [user]);

    const badge = useMemo(() => {
        if (agentStatus === undefined) return null;
        const devices = agentStatus ? Object.values(agentStatus.devices || {}) : [];
        if (!devices.length && agentStatus?.lastSeen) devices.push(agentStatus);
        if (!devices.length) {
            return {
                color: '#64748B', bg: '#F1F5F9', border: '#E2E8F0',
                text: '⚪ 에이전트 연결 이력 없음 — 덴클 에이전트를 설치하고 기공소 계정으로 로그인하면 CAD 파일이 자동 수집됩니다.',
            };
        }
        const latest = devices.reduce((a, b) => (toMs(b.lastSeen) > toMs(a.lastSeen) ? b : a));
        const ms = toMs(latest.lastSeen);
        const dev = latest.deviceName ? ` (${latest.deviceName}${latest.version ? `, v${latest.version}` : ''})` : '';
        if ((Date.now() - ms) / 60000 <= 10) {
            return {
                color: '#15803D', bg: '#EDFBF1', border: '#BBF7D0',
                text: `🟢 에이전트 연결됨 · ${agoText(ms)}${dev}`,
            };
        }
        return {
            color: '#B45309', bg: '#FFFBEB', border: '#FDE68A',
            text: `🟡 마지막 연결 ${agoText(ms)}${dev} — 에이전트가 실행 중인지 확인하세요. 꺼져 있으면 그동안의 CAD 작업이 수집되지 않아 명세서에 빠질 수 있습니다.`,
        };
    }, [agentStatus]);

    if (!badge) return null;
    return (
        <div style={{ padding: '7px 12px', borderRadius: 8, fontSize: 12.5, fontWeight: 700, lineHeight: 1.5, color: badge.color, background: badge.bg, border: `1px solid ${badge.border}`, ...style }}>
            {badge.text}
        </div>
    );
}

export default AgentStatusBanner;
